import { Component, OnInit } from '@angular/core';
import { ContabilidadService, PagosService } from '../../../services/service.index';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import swal2 from 'sweetalert2';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-options',
  templateUrl: './cuentascontables.component.html',
  styles: []
})
export class CuentasContablesComponent implements OnInit {

  constructor(
               public _contabilidad: ContabilidadService,
               public _pagosservice: PagosService,
               public router: Router,
               public http: HttpClient ) { }

  cc: any[] = [];
  cols: any[];
  selectedFac: any[];
  tieneacceso = false;
  // [22/09/2026] Diccionario id_cadena -> nombre_cadena para resolver company_id
  // en el listado (el endpoint del catálogo solo devuelve el id numérico).
  cadenasById: { [id: string]: string } = {};
  ngOnInit() {
    swal2.fire({
      title: 'Cargando',
      allowOutsideClick: false
 });
    swal2.showLoading();
   // this.getAcceso('/options');
    // [22/09/2026] Se carga en paralelo el catálogo de cuentas y el de cadenas
    // para poder resolver company_id -> nombre_cadena antes de pintar la tabla.
    // Se usa la firma de forkJoin con array porque el proyecto está en RxJS 6.4
    // (la variante con object literal se agregó en 6.5).
    forkJoin([
      this._contabilidad.getCuentasContables(),
      this._pagosservice.getCadenas()
    ]).subscribe(([cuentas, cadenas]: [any[], any[]]) => {
      this.cadenasById = {};
      for (const prop in cadenas) {
        this.cadenasById[cadenas[prop].id_cadena] = cadenas[prop].nombre_cadena;
      }
      // Enriquece cada cuenta con el nombre de la cadena para que la p-table
      // pueda mostrarlo y filtrarlo con el filtro global de texto.
      this.cc = cuentas.map(cta => ({
        ...cta,
        company_name: cta.company_id ? (this.cadenasById[cta.company_id] || '') : ''
      }));
      swal2.close();
    }, (err) => {
      swal2.fire({ title: 'Ocurrio un error al cargar la información', allowOutsideClick: false });
    });

    this.cols = [

      { field: 'account', header: 'Cuenta' },
      { field: 'accounting_key', header: 'Clave contable' },
      { field: 'accounting_name', header: 'Nombre cuenta' },
      { field: 'accounting_type', header: 'Tipo cuenta' },
      { field: 'assigment', header: 'Asignacion' },
      { field: 'center', header: 'Centro' },
      { field: 'cost_center', header: 'Centro de coste' },
      { field: 'definition', header: 'Definicion' },
      { field: 'pep_element', header: 'Elemento pep' },
      { field: 'profit_center', header: 'Centro de beneficio' },
      { field: 'tax_indicator', header: 'Tax' },
      { field: 'bank', header: 'Banco' },
      // [22/09/2026] Nuevas columnas del ajuste de póliza contable: cada cuenta
      // ahora puede diferenciarse por cadena y moneda.
      { field: 'company_name', header: 'Cadena' },
      { field: 'currency', header: 'Moneda' },
      { field: 'herramientas', header: 'Herramientas' },

  ];
  
  }

  borraCuentaContable( id: string ) {
    swal2.showLoading();
    swal2.fire({
      title: 'Desea Eliminar la cuenta contable',
      text: 'Seleccionada',
      icon: 'question',
      showConfirmButton: true,
      showCancelButton: true,
      allowOutsideClick: false
    }). then ( resp => {
      if ( resp.value) {

        this._contabilidad.borraCuentaContable( id ).subscribe( () => {
          swal2.close();
          swal2.fire({
            title: 'La cuenta contable',
            text: 'fue eliminada con exito',
            icon: 'success',
            showConfirmButton: true,
            showCancelButton: false,
            allowOutsideClick: false
          }). then ( res => {

            if ( res.value ) {
              this.ngOnInit();
            }

          } );

        }, (err) => {
          swal2.close();
          console.log(err);
          swal2.fire({
            title: 'Ocurrio un error',
            text: '',
            icon: 'error',
            showConfirmButton: true,
            showCancelButton: false,
            allowOutsideClick: false
          }). then ( res => {
            if ( res.value ) {
              this.ngOnInit();
            }
          } );
         } );

      }
    });

  }

}
